import { useState } from "react";
import { History } from "lucide-react";
import { APP_VERSION, CHANGELOG } from "../data/changelog";

export default function Updates() {
  const [openVersion, setOpenVersion] = useState(null);

  const toggle = (version) => {
    setOpenVersion((current) => current === version ? null : version);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-5" data-testid="updates-page">
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
              <History size={20} />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold text-slate-800">Aggiornamenti LanuseiLAB</h1>
              <p className="text-sm text-slate-500 mt-1">Storico delle principali evoluzioni del gestionale.</p>
            </div>
          </div>
          <div className="self-start sm:self-auto rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1.5 text-xs font-semibold whitespace-nowrap">
            Versione attuale v{APP_VERSION}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        {CHANGELOG.map((release, index) => {
          const open = openVersion === release.version;
          return (
            <div key={release.version} className={index > 0 ? "border-t border-slate-100" : ""}>
              <button
                type="button"
                onClick={() => toggle(release.version)}
                data-testid={`update-${release.version}`}
                className="w-full flex items-center gap-3 px-4 sm:px-5 py-3.5 text-left hover:bg-slate-50 transition-colors"
                aria-expanded={open}
              >
                <div className="min-w-0 flex-1 flex flex-wrap items-center gap-x-2 gap-y-1">
                  <span className="font-semibold text-slate-800">v{release.version}</span>
                  <span className="text-slate-300">—</span>
                  <span className="text-sm text-slate-500">{release.date}</span>
                  {index === 0 && (
                    <span className="text-[10px] uppercase tracking-wider font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">Attuale</span>
                  )}
                </div>
                <span className="w-8 h-8 rounded-full border border-slate-200 bg-white flex items-center justify-center text-lg leading-none font-light text-slate-500 shrink-0">
                  {open ? "−" : "+"}
                </span>
              </button>

              {open && (
                <div className="px-4 sm:px-5 pb-4" data-testid={`update-details-${release.version}`}>
                  <div className="rounded-xl bg-slate-50 border border-slate-100 p-4">
                    <p className="text-sm font-semibold text-slate-700 mb-2">{release.title}</p>
                    <ul className="space-y-1.5">
                      {release.items.map((item) => (
                        <li key={item} className="text-sm text-slate-600 flex gap-2">
                          <span className="text-blue-400 mt-0.5">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <p className="text-xs text-slate-400 px-1">
        Lo storico iniziale è stato ricostruito dalle modifiche registrate nel repository del progetto.
      </p>
    </div>
  );
}
